import React from 'react';
import styles from './Checkbox.module.css';

const Checkbox = ({
  label,
  description,
  disabled = false,
  className,
  ...props
}) => {
  const checkboxClasses = [
    styles.checkbox,
    disabled && styles.disabled,
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={styles.container}>
      <label className={styles.label}>
        <input
          type="checkbox"
          className={checkboxClasses}
          disabled={disabled}
          {...props}
        />
        <span className={styles.checkboxControl}></span>
        <span className={styles.labelText}>{label}</span>
      </label>
      {description && (
        <p className={styles.description}>{description}</p>
      )}
    </div>
  );
};

const CheckboxGroup = ({
  label,
  options = [],
  description,
  disabled = false,
  value = [],
  onChange,
  name,
}) => {
  const handleChange = (optionValue) => (e) => {
    const newValue = e.target.checked
      ? [...value, optionValue]
      : value.filter(v => v !== optionValue);
    onChange?.(newValue);
  };

  return (
    <div className={styles.groupContainer}>
      {label && <div className={styles.groupLabel}>{label}</div>}
      <div className={styles.checkboxGroup}>
        {options.map((option) => (
          <Checkbox
            key={option.value}
            name={name}
            label={option.label}
            checked={value.includes(option.value)}
            onChange={handleChange(option.value)}
            disabled={disabled || option.disabled}
          />
        ))}
      </div>
      {description && (
        <p className={styles.description}>{description}</p>
      )}
    </div>
  );
};

export { Checkbox, CheckboxGroup }; 